import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

declare global {
  interface Window {
    hbspt?: {
      forms: {
        create: (options: {
          region: string;
          portalId: string;
          formId: string;
          target: string;
        }) => void;
      };
    };
  }
}

const HUBSPOT_SCRIPT_ID = 'hs-forms-eu1';
const HUBSPOT_SCRIPT_SRC = 'https://js-eu1.hsforms.net/forms/embed/v2.js';

/**
 * Configuración del formulario embebido de HubSpot.
 * TODO: CONFIGURAR EN PROYECTO DESTINO si el formulario de HubSpot debe apuntar a
 * un portal/formulario distinto en el proyecto anfitrión — estos valores son los
 * originales de la landing Inviertis auditada.
 */
export const HUBSPOT_FORM_CONFIG = {
  region: 'eu1',
  portalId: '7733651',
  formId: '9f8f275c-fffd-4b39-a51a-5a15a7cf97ea',
} as const;

/**
 * Encapsula la carga e inicialización del formulario embebido de HubSpot.
 * El formulario original no usa campos Angular controlados (no hay Reactive Forms
 * que aplicar): HubSpot inyecta su propio <form> dentro del contenedor indicado.
 * SSR-safe: no toca `window`/`document` fuera de isPlatformBrowser.
 */
@Injectable()
export class LandingFormService {
  private readonly isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) platformId: object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  loadAndRenderForm(targetElementId: string): void {
    if (!this.isBrowser) {
      return;
    }
    this.loadScript()
      .then(() => this.renderForm(targetElementId))
      .catch((err) => console.error('No se pudo cargar el formulario de HubSpot', err));
  }

  private loadScript(): Promise<void> {
    return new Promise((resolve) => {
      if (document.getElementById(HUBSPOT_SCRIPT_ID)) {
        resolve();
        return;
      }
      const script = document.createElement('script');
      script.id = HUBSPOT_SCRIPT_ID;
      script.src = HUBSPOT_SCRIPT_SRC;
      script.async = true;
      script.defer = true;
      script.onload = () => resolve();
      document.body.appendChild(script);
    });
  }

  private renderForm(targetElementId: string): void {
    const target = document.getElementById(targetElementId);
    if (!window.hbspt || !target) {
      return;
    }
    target.innerHTML = '';
    window.hbspt.forms.create({
      region: HUBSPOT_FORM_CONFIG.region,
      portalId: HUBSPOT_FORM_CONFIG.portalId,
      formId: HUBSPOT_FORM_CONFIG.formId,
      target: `#${targetElementId}`,
    });
  }
}
